module.exports = __webpack_public_path__ + "assets/img/kv-5854ebe8.png";